export const logTypeOptions: string[] = ['E-mail', 'SMS', 'Ligação', 'WHATSAPP']

export const handleLogTypeParam = (value: string): string => {
  const option = {
    'E-mail': 'EMAIL',
    SMS: 'SMS',
    Ligação: 'LIGACAO',
    WHATSAPP: 'WHATSAPP',
  }

  return option[value]
}

export const INITIAL_SEARCH_PAYLOAD = {
  endDate: null,
  initialDate: null,
  logType: 'E-mail',
  searchTerm: '',
  itemsPerPage: 10,
  page: 1,
  totalPages: 0,
}

export const INCORRECT_DATE_ORDER = 'Data inicial maior que a data final'
